<template>
  <div class="container-fluid">
    <div class="row">
      <div class="col-12">
        <div class="mb-4">
          <h4 class="mb-1">Alta de usuario</h4>
          <p class="text-muted mb-0">Registrar un nuevo usuario en el sistema</p>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <form class="theme-form" @submit.prevent="submit">
              <div v-if="successMessage" class="alert alert-success">
                {{ successMessage }}
              </div>
              <div v-if="errorMessage" class="alert alert-danger">
                {{ errorMessage }}
              </div>
              <div class="row">
                <div class="col-md-6">
                  <div class="form-group">
                    <label class="col-form-label">Nombre <span class="text-danger">*</span></label>
                    <input v-model="form.name" class="form-control" type="text" placeholder="Ingrese el nombre completo"
                      required />
                  </div>
                  <div class="form-group">
                    <label class="col-form-label">Contraseña <span class="text-danger">*</span></label>
                    <div class="form-input position-relative">
                      <input v-model="form.password" :type="showPassword ? 'text' : 'password'" class="form-control"
                        placeholder="Mínimo 6 caracteres" required minlength="6" />
                      <div class="show-hide">
                        <span class="show" @click="showPassword = !showPassword" />
                      </div>
                    </div>
                    <small class="form-text text-muted">La contraseña debe tener al menos 6 caracteres</small>
                  </div>

                  <div class="form-group">
                    <label class="col-form-label">Estado <span class="text-danger">*</span></label>
                    <select v-model="form.status" class="form-control" required>
                      <option value="active">Activo</option>
                      <option value="inactive">Inactivo</option>
                    </select>
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="form-group">
                    <label class="col-form-label">Email <span class="text-danger">*</span></label>
                    <input v-model="form.email" class="form-control" type="email" placeholder="usuario@ejemplo.com"
                      required />
                  </div>
                  <div class="form-group">
                    <label class="col-form-label">Confirmar contraseña <span class="text-danger">*</span></label>
                    <input v-model="form.passwordConfirm" :type="showPassword ? 'text' : 'password'"
                      class="form-control" placeholder="Repita la contraseña" required />
                    <small v-if="form.password && form.passwordConfirm && form.password !== form.passwordConfirm"
                      class="text-danger">
                      Las contraseñas no coinciden
                    </small>
                  </div>

                </div>
              </div>
              <div class="form-group mb-0 mt-4 d-flex justify-content-end">
                <button type="button" class="btn btn-warning mr-2" :disabled="loading" @click="resetForm">
                  Limpiar
                </button>
                <button type="submit" class="btn btn-primary" :disabled="loading || !isFormValid">
                  {{ loading ? 'Creando...' : 'Crear usuario' }}
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { usersApi } from '@/services/api';

export default {
  name: 'AltaUsuariosPage',
  data() {
    return {
      form: {
        name: '',
        email: '',
        password: '',
        passwordConfirm: '',
        status: 'active',
        sucursal: '',
        rol: '',
      },
      showPassword: false,
      loading: false,
      errorMessage: '',
      successMessage: '',
    };
  },
  computed: {
    isFormValid() {
      const { name, email, password, passwordConfirm } = this.form;
      return (
        name.trim() &&
        email.trim() &&
        password.length >= 6 &&
        password === passwordConfirm
      );
    },
  },
  methods: {
    async submit() {
      if (!this.isFormValid) return;

      this.errorMessage = '';
      this.successMessage = '';
      this.loading = true;

      try {
        const status = this.form.status === 'active' ? 'active' : 'inactive';
        await usersApi.create({
          name: this.form.name.trim(),
          email: this.form.email.trim(),
          password: this.form.password,
          status,
        });

        this.successMessage = 'Usuario creado correctamente.';
        this.resetForm();
      } catch (err) {
        this.errorMessage = err.message || 'Error al crear usuario';
      } finally {
        this.loading = false;
      }
    },
    resetForm() {
      this.form = {
        name: '',
        email: '',
        password: '',
        passwordConfirm: '',
        status: 'active',
        sucursal: '',
        rol: '',
      };
      this.errorMessage = '';
    },
  },
};
</script>
